export const iconHref = (name: string): string => `assets/icons/command-center-icons.svg#${name}`;
